module.exports = __webpack_public_path__ + "static/media/directions.4b41bee6.svg";